import { Image, Text, View } from 'components';
import Base, { Config } from 'components/rent/Base';
import React from 'react';
import styles from './index.module.scss';


const LEVEL_SILVER = 1
const LEVEL_GOLD = 2
const LEVEL_KING = 3   //2022-05-18 新增



interface State {
  vipList: {
    days: number
    id: number
    info_list: any
    level: number   //1：银会员；   2：金会员  3皇冠会员
    // type: number    //1长期；  2替班
    name: string
    price: string
    cost: string
    status: number
  }[]
  currentLevel: 1 | 2  //当前选中的
  vipInfo: any,
  AdList?: any[]
}

export default class VipCompaire extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '会员特权'
  };

  public state: State = {
    vipList: [],
    currentLevel: LEVEL_GOLD,
    vipInfo: {},
  };

  public async didMount() {
    // await this.getUserInfo();
    const params:any = this.navigator.getParams(' '+this.props.location.search) || {}
    const col = (this.props.location.state || {})
    this.setState({
      // type: params.type || col || 1,
    })


    this.init(params)
    this.getAdLists()
  }

  public render() {
    const { currentLevel, vipInfo, vipList, AdList } = this.state;

    return vipList.length > 0? (
      <View className={styles.container}>
        
          <View className={styles.adBox}>
            {AdList && AdList.map((ad, ind) => (
              <Image 
                className={styles.adImg} 
                src={ad.url} 
              />
            ))}
          </View>

          <View className={styles.divider}>
            <Image src={this.assets.megatron.arrDownDouble} style={{width: '16px'}}></Image>
          </View>

          <View className={styles.tabBox}>
            {[this.vipSilver, this.vipGold, this.vipKing].map((e, ind) => (
              <View className={this.cx(styles.tabItem, styles['tabItem'+ind])} 
                onClick={() => {
                  this.navigator.push('rentVipDetail', {level: e.level})
                }}
              >
                <View className={styles.itemInner}>

                  {(e.level == 2) &&  
                    <Image src={this.assets.megatron.rechargeOnsale} className={styles.recmd} />
                  }
                  <View className={styles.le}>
                    <View className={styles.icoBox}>
                      <Image src={e.defaultIco} className={styles.ico} />
                    </View>
                    <View className={styles.cont}>
                      <Text className={styles.h2}>{(e.name || '').substring(0,4)}
                        <Text className={styles.co}>{(e.name || '').substring(4,6)}</Text>
                      </Text>
                      <Text className={styles.p}>
                        享
                        <Text>价值{Number(e.cost || 0)}
                        元的
                        </Text>
                        {e.info_list.length}大特权
                      </Text>
                    </View>
                  </View>
                  <View className={styles.ri}>
                    <Text>
                      <Text className={styles.sm}>¥</Text>
                      {Number(e.price)}
                      <Text className={styles.sm}>{'介绍>>'}</Text>
                    </Text>
                  </View>

                </View>
              </View>
            ))}
          </View>

          
          <View className={styles.extraBtn}>
            <View className={styles.btn} onClick={() => {
              this.navigator.push('rentVipCompaire')
            }}>
              <Text className={styles.txt}>查看更多权益对比</Text>
              <View className={styles.arr} />
            </View>
          </View>

      </View>
    ): '';
  }

  private get vipKing() {
    const { vipList } = this.state
    let res:any = vipList.find(e => e.level == LEVEL_KING) || {}
    return {...res, alias: '皇冠',
      defaultIco: this.assets.rent.crownG,
    }
  }
  private get vipGold() {
    const { vipList } = this.state
    let res:any = vipList.find(e => (e.level == LEVEL_GOLD)) || {}
    return {...res, alias: '金钻',
      defaultIco: this.assets.rent.diamondG,
    }
  }
  private get vipSilver() {
    const { vipList } = this.state
    let res:any =  vipList.find(e => (e.level == LEVEL_SILVER)) || {}
    return {...res, alias: '银钻',
      defaultIco: this.assets.rent.diamondG,
    }
  }
  private get vipSelected() {
    const { vipList, currentLevel } = this.state
    let res:any =  vipList.find(e => (e.level == currentLevel)) || {}
    return res
  }
  private get vipInfoGold() {
    return this.vipGold? this.vipGold.info_list || []: []
  }
  private get vipInfoSilv() {
    return this.vipSilver? this.vipSilver.info_list || []: []
  }


  private get isMiniProgram() {
    return this.interface.uaEnv.isWechatMp()
  }




  private handleBack = () => {
    if(this.interface.uaEnv.isWechatMp()){
      window.wx.miniProgram.navigateBack()
    }else if(this.interface.uaEnv.isReactNative) {
      this.interface.postMessage('back')
    }else {
      this.navigator.back()
    }
  }

  private handleClickPay = (obj) => {
    this.setState({
      currentLevel: obj.level
    })
    
    if(this.isMiniProgram) {
      window.wx.miniProgram.redirectTo({url: '/pages/vip/webview/index?type=compaire&payId='+obj.id})
    }else {
      this.handlePay(obj.id)
    }
  }

  private handlePay = async (id) => {
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }
    
    const response = await this.apiClient.base.vipPlusBuy({
      id
    });

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('购买成功');

      }
    });
  }


  private getUserInfo = async () => {
    // const { body } = await this.apiClient.base.userinfo();

    // const res = await this.apiClient.base.vipPlusInfo()
    // this.setState({
    //   vipInfo: body
    // })
  }

  private getVipLists = async() => {
    const { body } = await this.apiClient.base.vipPlus({})
    if(body) {
      this.setState({
        vipList: body || []
      })
    }
  }  

  private getAdLists = async() => {
    const { body } = await this.apiClient.base.ad({
      page: 'pages/vip/index?type=banner',
      type: 1  //1图片 2视频
    })

    this.setState({
      AdList: body || []
    })
  }

  private init = async (params) => {
    // this.getVipLists(); return; //测试
    const { body } = await this.apiClient.base.userinfo();

    // this.setState({
    //   userinfo:body
    // })
    // this.setState({
    //   userinfo: {"id":2,"nickname":"\u6211\u8ba4\u8bc6\u4f60","realname":"","mobile":"15267286145","mobile_location":"\u6d59\u6c5f\u53f0\u5dde(\u79fb\u52a8)","avatar":"https:\/\/assets.gongji58.com\/2019-02-27\/clavmj717r1551257843.png!medium","sex":1,"type":1,"reg_ip":"223.104.246.162","point":0,"id_number":"","address":"","address_id":null,"description":"","store_name":"\u6211\u8ba4\u8bc6\u4f60","store_description":"\u6d4b\u8bd5\u4e2a\u5443\u5443\u5443","car_total":54,"want_total":3,"job_total":12,"resume_total":11,"report_total":1,"last_login":"2021-06-11 11:40:54","ban_desc":"","developer":1,"status":3,"ctime":"2019-02-27 16:57:23","utime":"2020-09-15 11:38:48","is_manager":true,"id_checks":false,"pub_total":0}
    // })

    if(!body) {
      return false;
    }
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }

    if(params.mode == 'ignoreArea') {
      this.getVipLists();
      console.log('ignoreArea');
      return;
    }
    
    if(body && body.area_ban) {
      //判断手机号归属地是否在禁止城市
      alert('功能升级中！')
      return false;
    }else {
      this.getVipLists()
    }

    
  }
  
}
